import { useState, useMemo } from 'react';

export const useHandleFiles = () => {
    const [ files, setFiles ] = useState({
        deleteFiles: [],
        qrFiles: []
    });
    const [logo, setLogo] = useState({ file: null, delete: false });

    const filesReset = () => {
        setFiles({ qrFiles: [], deleteFiles: [] });
        setLogo({ file: null, delete: false });
    };

    return useMemo(() => ({ files, setFiles, logo, setLogo, filesReset }), [files, logo]);
};
